import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PageBuilder from '@hellodarwin/app-contentful/lib/builder/pageBuilder';
import { usePage } from '@hellodarwin/app-contentful/lib/hooks/usePage';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useLocation } from 'react-router-dom';
import { usePremiumAccess } from '../../../../providers/premium-access-provider';
import PremiumOverlayCard from './premium-overlay-card';
import { PremiumFeatureOverlayContainer, PremiumFeatureOverlayWrapper, } from './styles';
const PremiumFeatureOverlay = ({ children }) => {
    var _a, _b, _c;
    const { handleCheckout } = (_a = usePremiumAccess()) !== null && _a !== void 0 ? _a : {};
    const { data, loading, error } = (_b = usePage()) !== null && _b !== void 0 ? _b : {};
    if (loading)
        return null;
    if (error)
        return null;
    if (data) {
        if ((_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.components) {
            return (_jsx(PageBuilder, { components: data.fields.components, handlePaymentPage: handleCheckout }));
        }
    }
    return (_jsxs(PremiumFeatureOverlayWrapper, { children: [children, _jsx(PremiumFeatureOverlayContainer, {}), _jsx(PremiumOverlayCard, {})] }));
};
const PremiumFeatureOverlayWithValidation = ({ children, }) => {
    const { isPageAccessible } = usePremiumAccess();
    const { pathname } = useLocation();
    const { app } = usePlatform();
    const isAccessible = isPageAccessible(pathname);
    if (isAccessible || app === 'admin')
        return _jsx(_Fragment, { children: children });
    return _jsx(PremiumFeatureOverlay, { children: children });
};
export default PremiumFeatureOverlayWithValidation;
